import type { CityConfig } from "../city-template/types";

export const towsonConfig: CityConfig = {
  city: "Towson",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "towson",
  route: "/cities/towson",
  title: "Emergency Passport Towson, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Towson, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Towson, Lutherville, Timonium, Parkville, and Pikesville residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Towson, MD",
  heroSubtitle: "Towson travelers — from Towson University students to Baltimore County professionals to suburban families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Baltimore County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Charming%20downtown%20Towson%20Maryland%20with%20Towson%20University%20campus%20in%20the%20background%2C%20tree-lined%20streets%20with%20historic%20and%20modern%20buildings%2C%20warm%20autumn%20afternoon%20lighting%2C%20professional%20photography%2C%20clean%20architectural%20details%2C%20no%20visible%20text%20or%20people%2C%20green%20lawns%20and%20brick%20walkways%2C%20college%20town%20atmosphere%20with%20suburban%20charm%2C%20Baltimore%20County%20courthouse%20area&width=1800&height=700&seq=towson-hero-001&orientation=landscape",
  heroImageAlt: "Charming downtown Towson Maryland with Towson University campus and tree-lined streets",
  geoPosition: "39.4015;-76.6019",
  geoPlacename: "Towson, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 55–65 minutes from Towson via I-695 S and I-295 S",
  },
  nearbyCitiesZips: [
    { name: "Towson", zips: "21204, 21252, 21284, 21285, 21286" },
    { name: "Lutherville", zips: "21093" },
    { name: "Timonium", zips: "21093" },
    { name: "Parkville", zips: "21234" },
    { name: "Pikesville", zips: "21208, 21282" },
    { name: "Hampton", zips: "21286" },
    { name: "Rosedale", zips: "21237" },
    { name: "Overlea", zips: "21236" },
    { name: "Baltimore", zips: "21201, 21202, 21205, 21206, 21207, 21209, 21210, 21211, 21212, 21213, 21214, 21215, 21216, 21217, 21218, 21222, 21223, 21224, 21225, 21226, 21227, 21229, 21230, 21231, 21233, 21234, 21236, 21237, 21239, 21251" },
    { name: "Catonsville", zips: "21228, 21229, 21250" },
    { name: "Ellicott City", zips: "21041, 21042, 21043" },
    { name: "Columbia", zips: "21044, 21045, 21046, 21075" },
    { name: "Hunt Valley", zips: "21030, 21031" },
    { name: "Cockeysville", zips: "21030, 21031" },
    { name: "Reisterstown", zips: "21136" },
    { name: "Owings Mills", zips: "21117" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Towson and Baltimore County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-school-line", title: "University & County Hub", desc: "Serving Towson University and Baltimore County government travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Emergency passport help in Columbia, MD", route: "/cities/columbia" },
    { name: "Urgent passport services in Ellicott City, MD", route: "/cities/ellicott-city" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Towson, Maryland remotely via secure registered courier. We do not have a walk-in office in Towson — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Towson travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Towson, Lutherville, Timonium, Parkville, Pikesville, and greater Baltimore County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Towson area and greater Baltimore County. From the Towson University campus and the bustling downtown district to the quiet suburban neighborhoods of Lutherville and Timonium, from the diverse communities of Parkville and Pikesville to the rolling hills of Hunt Valley and Cockeysville — we serve all of Towson's communities.",
  nearbyCitiesIntro: "We serve Towson and nearby communities including Lutherville, Timonium, Parkville, Pikesville, Hampton, Rosedale, Overlea, Baltimore, Catonsville, Ellicott City, Columbia, Hunt Valley, Cockeysville, Reisterstown, and Owings Mills. We also serve travelers across the greater Baltimore metro area who prefer our expedited service.",
  howItWorksIntro: "Most Towson travelers complete everything online and ship documents overnight. No need to drive 55–65 minutes to downtown DC or navigate the Baltimore Beltway during rush hour.",
  mistakesIntro: "Towson is a university town and Baltimore County government center with a mix of students, professionals, and suburban families. Here are the most common passport mistakes we see from Towson travelers.",
  testimonialsIntro: "Towson travelers — from university students to county professionals to suburban families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Towson, MD? Here are the most common ones we hear from Baltimore County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for university and county travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 55–65 min to downtown DC", "Full day commitment — challenging for students and professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Towson travelers with immediate departure needs — as fast as 24 hours. Perfect for study abroad, business trips, and last-minute family travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Student and professional travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Towson adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Towson address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Towson residents and families — including students applying for study abroad.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Towson residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Towson families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Towson residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Towson MD", description: "Urgent passport processing for Towson Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Towson MD", description: "Fast passport renewal for Towson Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Towson MD", description: "New passport application services for Towson Maryland residents applying for their first passport." },
    { name: "Child Passport Towson MD", description: "Minor passport services for Towson Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jessica M.",
      location: "Towson, MD",
      rating: 5,
      text: "Study abroad program in Spain starting in 8 days. Fast Passport Center helped me navigate the first-time application process and had my passport ready in 4 days. Saved my semester abroad.",
      service: "First-Time Passport",
    },
    {
      name: "Brian H.",
      location: "Lutherville, MD",
      rating: 5,
      text: "Family cruise to the Caribbean with 10 days notice. Four passports processed in under a week. The agent handled everything — we just shipped the docs from the UPS Store on York Rd.",
      service: "Family Passport Bundle",
    },
    {
      name: "Stephanie W.",
      location: "Timonium, MD",
      rating: 5,
      text: "Business trip to London with 7 days notice. Fast Passport Center had my renewed passport ready in 2 days. No need to drive to DC or Baltimore — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Carlos R.",
      location: "Parkville, MD",
      rating: 5,
      text: "Last-minute family emergency required travel to Mexico. They understood the urgency and had my passport in my hands within 36 hours. Professional service that respects working-family timelines.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "towson-1",
      name: "Towson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2330 York Rd",
      city: "Towson",
      state: "MD",
      zip: "21204",
      phone: "(410) 337-6332",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Towson, on York Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Towson acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient parking and access from I-695.",
      icon: "ri-mail-line",
    },
    {
      id: "towson-2",
      name: "Lutherville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17010 York Rd",
      city: "Lutherville",
      state: "MD",
      zip: "21093",
      phone: "(410) 560-3373",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lutherville, approximately 3 miles north of downtown Towson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Lutherville and northern Baltimore County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "towson-3",
      name: "Pikesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1721 Reisterstown Rd",
      city: "Pikesville",
      state: "MD",
      zip: "21208",
      phone: "(410) 484-4414",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pikesville, approximately 5 miles west of downtown Towson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Pikesville and western Baltimore County residents. Good alternative when Towson appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "towson-4",
      name: "Baltimore County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "401 Bosley Ave",
      city: "Towson",
      state: "MD",
      zip: "21204",
      phone: "(410) 887-2602",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Towson, county courthouse district",
      website: "https://www.baltimorecountymd.gov/",
      websiteLabel: "Baltimore County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Located in the historic courthouse district.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 55–65 min drive to downtown DC", fpc: "No — ship from Towson" },
    { feature: "Student Travel Support", agency: "No flexibility for study abroad deadlines", fpc: "Yes — we handle student and academic cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Towson students and busy professionals often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Towson sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Towson and Baltimore County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Towson Post Office appointments fill up fast, especially during summer and semester-break travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Towson residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Towson, Lutherville, or Timonium." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Towson Town Center or along York Road." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Towson address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Towson, MD?", a: "Fast Passport Center offers emergency passport processing in Towson, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (55–65 minutes from Towson) — without you needing to make the drive or fight Beltway traffic." },
    { q: "Does Towson have its own passport agency?", a: "No — neither Towson nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 55–65 minutes from Towson via I-695 S and I-295 S. Fast Passport Center's courier service means Towson residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Lutherville or Timonium?", a: "Absolutely. Fast Passport Center serves all of the Towson area including Lutherville, Timonium, Parkville, Pikesville, Hampton, and Rosedale. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Towson, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Towson travelers use for international flights?", a: "Most Towson residents fly internationally through Baltimore-Washington International (BWI), approximately 25–35 minutes south via I-695 S. Reagan National (DCA) is 55–65 minutes south via I-695 S and I-295 S. Dulles International (IAD) is 60–75 minutes southwest via I-695 S and I-270 S. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Towson?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Towson, Lutherville, Timonium, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to downtown Towson?", a: "The Towson Post Office at 2330 York Rd is the primary downtown acceptance facility. The Baltimore County Clerk's Office at 401 Bosley Ave serves the county courthouse district. The Lutherville Post Office at 17010 York Rd serves northern Baltimore County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Towson residents should plan ahead, especially for study abroad programs and summer vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Towson", address: "8813 Loch Raven Blvd, Towson, MD 21286", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Towson", address: "1200 E Joppa Rd, Towson, MD 21286", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Towson", address: "1220 E Joppa Rd, Towson, MD 21286", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Towson", address: "1 E Joppa Rd, Towson, MD 21286", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Towson", address: "145 E Joppa Rd, Towson, MD 21286", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Baltimore County and Towson area. REAL ID processing available.", featured: true },
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Anne Arundel County and southern Baltimore County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "25–35 minutes from Towson via I-695 S",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary airport for Towson and Baltimore County travelers. Excellent domestic connections and international flights. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "55–65 minutes from Towson via I-695 S and I-295 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Closest airport for domestic connections. Limited international flights but excellent for connecting to major hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "60–75 minutes from Towson via I-695 S and I-270 S",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub with direct flights to Europe, Asia, and South America. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};